/**
 * Function for doing different scrollTo actions
 * this wraps the native available methods and handles browser compatability
 * can be used with a scrollable element, defaults to window
 * @param options
 * @param container
 */
export const scrollContainer = (
    options: ScrollToOptions,
    container?: HTMLElement | (Window & typeof globalThis)
): void => {
    const scrollableContainer = container || (window && window);

    if (!scrollableContainer) {
        return;
    }

    const scrollOptions = {
        top: options.top || 0,
        left: options.left || 0,
        behavior: options.behavior || 'smooth'
    };

    // If the browser supports scroll behaviour, this means the browser supports the scrollTo options object
    // If not we use the oldschool (x-coord, y-coord)
    if ('scrollBehavior' in document.documentElement.style) {
        scrollableContainer.scrollTo(options);
        return;
    }
    scrollableContainer.scrollTo(scrollOptions.left, scrollOptions.top);
};
